import React, { useState } from "react";
import submit from "submit-form";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";

export const AddNewChannelModal = ({ locals }) => {
  const { activeSubscribersList: subscribers = [] } = locals;
  const [channelNameState, setChannelNameState] = useState("");

  /**
   * Function to close the modal
   */
  const cancel = () => {
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        modal: "",
      },
    });
  };

  /**
   * Function to call the action to create a channel
   * @param {*} e
   */
  const createChannel = (e) => {
    e.preventDefault();
    if (channelNameState.length > 0) {
      const guests = subscribers.map(({ _id }) => _id);
      submit(`/actions/community-chat/create-channel`, {
        method: "POST",
        body: { subject: channelNameState, guests },
      });
    }
  };

  /**
   * Function to update the state of the input
   * @param {*} {target}
   */
  const handleChange = ({ target }) => {
    setChannelNameState(target.value);
  };

  return (
    <Modal className={"add-new-channel-modal"} title={"Add new channel"}>
      <div className="body">
        <label htmlFor="channel-name">Channel Name</label>
        <input
          id="channel-name"
          name="channelName"
          className="enter-channel-name"
          placeholder="Enter Channel Name"
          value={channelNameState}
          onChange={handleChange}
        />
      </div>
      <footer>
        <button data-button-type="secondary" onClick={cancel}>
          Cancel
        </button>

        <button data-button-type="primary" onClick={createChannel}>
          Next
        </button>
      </footer>
    </Modal>
  );
};

AddNewChannelModal.propTypes = {
  locals: PropTypes.object,
};
